import { AsYouType } from "libphonenumber-js";
import { i18n } from "@/packages/i18n";
import { useOrderFormStore } from "@/stores/forms/orderFormStore";

const { t } = i18n.global;

export default function baseFormValidators() {
  const isEmpty = (fieldName, fieldValue) => {
    return !fieldValue ? `The ${fieldName} field is required` : "";
  };

  const minLength = (fieldValue, min) => {
    // Todo: debounce the validation to give time for typing
    return fieldValue.length < min
      ? t("FormInput.error.minLengthErrorMsg", { min })
      : "";
  };

  const isEmail = (fieldName, fieldValue) => {
    const regex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return !regex.test(fieldValue)
      ? t("EmailField.error.emailAddressErrorMsg")
      : "";
  };

  const getMobileErrorMsg = (mobile, internationalCode) => {
    const asYouType = new AsYouType(`${internationalCode}`);
    asYouType.input(`${mobile}`);
    return !asYouType.isValid()
      ? t("MobileField.error.mobileNumberErrorMsg")
      : "";
  };

  const getMobileCustomErrorMsg = (mobile, internationalCode) => {
    const asYouType = new AsYouType(`${internationalCode}`);
    asYouType.input(mobile);

    const orderStore = useOrderFormStore();

    // If empty array then assume all of the countries are included
    const allowedCountriesForMobileNumber =
      orderStore.getPaymentProvider?.allowed_countries_for_mobile || [];
    if (
      allowedCountriesForMobileNumber.length > 0 &&
      !allowedCountriesForMobileNumber.includes(asYouType.getNumber().country)
    ) {
      return `${t("MobileField.error.mobileNumberErrorMsgForCountry")} ${allowedCountriesForMobileNumber.join(", ")}`;
    }
    return "";
  };

  return {
    isEmpty,
    minLength,
    isEmail,
    getMobileErrorMsg,
    getMobileCustomErrorMsg,
  };
}
